<template>
    <swiper @swiper="onSwiper" :lazy="swiperSettings.lazy" :spaceBetween="swiperSettings.spaceBetween" :slidesPerView="swiperSettings.slidesPerView" :pagination='swiperSettings.pagination' :navigation="swiperSettings.navigation" :breakpoints="swiperSettings.breakpoints" class="compare-slider compare-slider--desc">
        <swiper-slide v-for="slide in currentCategory" class="compare-slider__item">
            <div class="compare-card">
                <div class="compare-card__design">
                    <a class="compare-card__design-img" href="#"><img :src="slide.map" alt="" loading="lazy"></a>
                    <div class="compare-card__item-label">Все размеры в мм</div>
                </div>
                <div class="compare-card__bottom">
                    <div class="compare-card__list">
                        <template v-for="param in slide.params" :key="param">
                            <template v-if="param.type === 'text'">
                                <div class="compare-card__item" :class="{same : isSame(param.name, param.value)}">
                                    <div class="compare-card__item-label">{{ param.name }}</div>
                                    <div class="compare-card__item-text">{{ param.value }}</div>
                                </div>
                            </template>
                            <template v-else-if="param.type === 'color'">
                                <div  class="compare-card__item">
                                    <div class="compare-card__item-label">{{ param.name }}</div>
                                    <div class="compare-card__item-text">
                                        <div class="colors">
                                            <span class="colors__item" v-for="color in param.value" :key="color" :style="`color: ${color}`"></span>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <div class="compare-card__item" :class="{same : isSame(param.name, param.value)}">
                                    <div class="compare-card__item-label">{{ param.name }}</div>
                                    <div class="compare-card__item-text">{{ param.value }}</div>
                                </div>
                            </template>
                        </template>

                    </div>
                    <div class="compare-card__list">
                        <div class="compare-card__list-title">Загрузки</div>
                        <div class="product-docs">
                            <template v-for="doc in slide.documents" :key="doc">
                                <a v-if="doc.code === 'instruction'"  class="product-docs__item" :href="doc.value" href="#" target="_blank">
                                    <div class="product-docs__item-name">
                                        <div class="product-docs__item-icon">
                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <path d="M1.5 0.5H6.80228L14.5 7.71662V15.5H1.5V0.5Z"
                                                      stroke="black"/>
                                                <path d="M7 1V8H14" stroke="black"/>
                                            </svg>
                                        </div>
                                        <span>Спецификация</span>
                                    </div>
                                    <div class="product-docs__item-info">PDF, 100КБ</div>
                                    <div :href="doc.value" :download="`${doc.name} - ${slide.name}`" class="product-docs__item-link download">Скачать</div>
                                </a>
                                <!--                                    <a class="product-docs__item" href="#" target="_blank">-->
                                <!--                                        <div class="product-docs__item-name">-->
                                <!--                                            <div class="product-docs__item-icon">-->
                                <!--                                                <svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">-->
                                <!--                                                    <path d="M8.69185 11.5H3.66704C3.45132 10.6059 2.95631 9.64346 2.18442 9.04213C1.23419 8.1742 0.641473 7.07373 0.534012 5.95218L0.534185 5.95216L0.532586 5.93911C0.208219 3.28968 2.37581 0.839772 5.44364 0.530414C8.50185 0.222025 11.1988 2.27992 11.4708 4.94563L11.4707 4.94563L11.4714 4.95151C11.6358 6.39377 11.087 7.88703 9.93668 8.8813L9.93658 8.88119L9.92762 8.88933C9.13192 9.61147 8.86238 10.6273 8.69185 11.5ZM3.7697 12.5H8.60698V15.5H3.816L3.7697 12.5Z" stroke="black"/>-->
                                <!--                                                </svg>-->
                                <!--                                            </div>-->
                                <!--                                            <span>EEE Label</span>-->
                                <!--                                        </div>-->
                                <!--                                        <div class="product-docs__item-info">PDF, 100КБ</div>-->
                                <!--                                        <div :href="doc.value" :download="`${doc.name} - ${slide.name}`" class="product-docs__item-link download">Скачать</div>-->
                                <!--                                    </a>-->
                                <a v-else-if="doc.code === '3dModel'" class="product-docs__item" :href="doc.value" target="_blank">
                                    <div class="product-docs__item-name">
                                        <div class="product-docs__item-icon">
                                            <svg width="14" height="16" viewBox="0 0 14 16" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <mask id="path-1-inside-1_2011_24871" fill="white">
                                                    <path d="M0 3L7 0L14 3V13L7 16L0 13V3Z"/>
                                                </mask>
                                                <path d="M-0.19696 3.45957L6.80304 6.45957L7.19696 5.54043L0.19696 2.54043L-0.19696 3.45957ZM7.19696 6.45957L14.197 3.45957L13.803 2.54043L6.80304 5.54043L7.19696 6.45957ZM6.5 6V16H7.5V6H6.5ZM0 3L-0.393919 2.08085L-1 2.3406V3H0ZM14 3H15V2.3406L14.3939 2.08085L14 3ZM14 13L14.3939 13.9191L15 13.6594V13H14ZM0 13H-1V13.6594L-0.393919 13.9191L0 13ZM7 16L6.60608 16.9191L7 17.088L7.39392 16.9191L7 16ZM7 0L7.39392 -0.919145L7 -1.08797L6.60608 -0.919145L7 0ZM13 3V13H15V3H13ZM1 13V3H-1V13H1ZM13.6061 12.0809L6.60608 15.0809L7.39392 16.9191L14.3939 13.9191L13.6061 12.0809ZM7.39392 15.0809L0.393919 12.0809L-0.393919 13.9191L6.60608 16.9191L7.39392 15.0809ZM0.393919 3.91915L7.39392 0.919145L6.60608 -0.919145L-0.393919 2.08085L0.393919 3.91915ZM6.60608 0.919145L13.6061 3.91915L14.3939 2.08085L7.39392 -0.919145L6.60608 0.919145Z" fill="black" mask="url(#path-1-inside-1_2011_24871)"/>
                                            </svg>
                                        </div>
                                        <span>3D-модель</span>
                                    </div>
                                    <div class="product-docs__item-info">PDF, 100КБ</div>
                                    <a :href="doc.value" :download="`${doc.name} - ${slide.name}`" class="product-docs__item-link download">Скачать</a>
                                </a>
                            </template>

                        </div>
                    </div>
                </div>
            </div>
        </swiper-slide>
    </swiper>
</template>

<script>
import {Swiper, SwiperSlide} from "swiper/vue/swiper-vue";
import SwiperCore, {Pagination, Navigation, Controller} from 'swiper';
import {mapState} from "vuex";
SwiperCore.use([Pagination, Navigation, Controller]);

export default {
    name: "DescSlider",
    components: {
        Swiper,
        SwiperSlide,
    },
    props: {
        categoryId: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            descSlider: null,
            swiperSettings: {
                slidesPerView: 1,
                    spaceBetween: 0,
                    lazy: {
                        loadPrevNext: true,
                    },
                    pagination: {
                        el: '.compare-slider--head .swiper-pagination',
                        type: 'fraction',
                    },
                    navigation: {
                        nextEl: '.compare-slider--head .swiper-button-next',
                        prevEl: '.compare-slider--head .swiper-button-prev',
                    },
                    breakpoints: {
                        1000: {
                            slidesPerView: 4,
                        },
                        720: {
                            slidesPerView: 3,
                        },
                        520: {
                            slidesPerView: 2,
                        },
                        420: {
                            slidesPerView: 1,
                        }
                    },
            }
        }
    },
    computed: {
        currentCategory: {
            get() {
                if (this.categoryId) {
                    return this.categories.find(i => i.ID === this.categoryId).items
                } else {
                    return this.productsList
                }
            },
        },
        isSame() {
            return (name, val) => {
                let same = true
                this.currentCategory.forEach((item) => {
                    if (item.params.find(i => i.name === name).value !== val) {
                        same = false
                    }
                })
                if (!this.highLight) {
                    return false
                } else {
                    return same
                }
            }
        },
        ...mapState({
            categories: state => state.categories,
            highLight: state => state.highlightSame,
            productsList: state => state.productsList,
        }),
    },
    methods: {
        onSwiper(swiper) {
            this.descSlider = swiper
        }
    }
}
</script>

<style scoped>

</style>